var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 39,
    viewBox: "0 0 198 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8669 0.0356445L24.1327 13.1643H37.937L26.7691 21.2783L31.0349 34.407L19.8669 26.293L8.69902 34.407L12.9648 21.2783L1.79687 13.1643H15.6012L19.8669 0.0356445Z",
    fill: "#D6FF63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8669 0.0356445L63.1327 13.1643H76.937L65.7691 21.2783L70.0349 34.407L58.8669 26.293L47.699 34.407L51.9648 21.2783L40.7969 13.1643H54.6012L58.8669 0.0356445Z",
    fill: "#D6FF63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8669 0.0356445L102.133 13.1643H115.937L104.769 21.2783L109.035 34.407L97.8669 26.293L86.699 34.407L90.9648 21.2783L79.7969 13.1643H93.6012L97.8669 0.0356445Z",
    fill: "#D6FF63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.867 0.0356445L141.133 13.1643H154.937L143.769 21.2783L148.035 34.407L136.867 26.293L125.699 34.407L129.965 21.2783L118.797 13.1643H132.601L136.867 0.0356445Z",
    fill: "#D6FF63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.867 0.0356445L183.133 13.1643H196.937L185.769 21.2783L190.035 34.407L178.867 26.293L167.699 34.407L171.965 21.2783L160.797 13.1643H174.601L178.867 0.0356445Z",
    fill: "#D6FF63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingsvg);
export default __webpack_public_path__ + "static/media/ratingsvg.331ad9fd3b730b7cc5bdec4a3e56642d.svg";
export { ForwardRef as ReactComponent };